const PATH = 'fe.pages.organization.add_members';

const messages = {
  addMember: {
    key: `${PATH}.add_member`,
    defaultValue: 'Add Member'
  },
  addingMember: {
    key: `${PATH}.adding_member`,
    defaultValue: 'Adding Member...'
  },
  goBack: {
    key: `${PATH}.go_back`,
    defaultValue: 'Go Back'
  },
  addAnotherMember: {
    key: `${PATH}.add_another_member`,
    defaultValue: 'Add Another Member Form'
  },
  removeMember: {
    key: `${PATH}.remove_member`,
    defaultValue: 'Delete Form'
  },
  usersAdded: {
    key: `${PATH}.users_added`,
    defaultValue: '{{count}} new member has been added'
  },
  userSubscriptionInviteAllowed: {
    key: `${PATH}.user_subscription_invite_allowed`,
    defaultValue:
      'User added successfully. You can now invite them to the subscription.'
  },
  userSubscriptionMember: {
    key: `${PATH}.user_subscription_member`,
    defaultValue:
      'User {{email}} added successfully. You can now view them in the subscription.'
  },
  fields: {
    email: {
      key: `${PATH}.fields.email`,
      defaultValue: 'Email'
    },
    emailPlaceholder: {
      key: `${PATH}.fields.email_placeholder`,
      defaultValue: 'Enter email address'
    },
    firstName: {
      key: `${PATH}.fields.first_name`,
      defaultValue: 'First Name'
    },
    firstNamePlaceholder: {
      key: `${PATH}.fields.first_name_placeholder`,
      defaultValue: 'Enter first name'
    },
    lastName: {
      key: `${PATH}.fields.last_name`,
      defaultValue: 'Last Name'
    },
    lastNamePlaceholder: {
      key: `${PATH}.fields.last_name_placeholder`,
      defaultValue: 'Enter last name'
    },
    role: {
      key: `${PATH}.fields.role`,
      defaultValue: 'Role'
    },
    rolePlaceholder: {
      key: `${PATH}.fields.role_placeholder`,
      defaultValue: 'Select role (optional)'
    },
    hierarchy: {
      key: `${PATH}.fields.hierarchy`,
      defaultValue: 'Hierarchy Association'
    },
    hierarchyPlaceholder: {
      key: `${PATH}.fields.hierarchy_placeholder`,
      defaultValue: 'Select hierarchy association for this member'
    },
    subscriptions: {
      key: `${PATH}.fields.subscriptions`,
      defaultValue: 'Subscriptions'
    },
    noSeatsRemaining: {
      key: `${PATH}.fields.no_seats_remaining`,
      defaultValue:
        'You cannot add members to this subscription because there are no seats available'
    },
    subscriptionRole: {
      key: `${PATH}.fields.subscription_role`,
      defaultValue: 'Subscription Role'
    },
    subscriptionRolePlaceholder: {
      key: `${PATH}.fields.subscription_role_placeholder`,
      defaultValue: 'Select subscription role'
    },
    noRoleRequired: {
      key: `${PATH}.fields.no_role_required`,
      defaultValue: 'This subscription does not require a role'
    }
  },
  errors: {
    email: {
      key: `${PATH}.errors.email`,
      defaultValue: 'You must provide a valid email address'
    },
    required: {
      key: `${PATH}.errors.required`,
      defaultValue: 'This field is required'
    },
    adminHierarchyRequired: {
      key: `${PATH}.errors.admin_hierarchy_required`,
      defaultValue: 'This field is required when Administrator role is selected'
    },
    subscriptionRoleRequiredFor: {
      key: `${PATH}.errors.subscription_role_required_for`,
      defaultValue: 'Select a role for {{name}}'
    }
  }
};

export default messages;
